/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export type QnaMakerQnaPromptSwagger = { displayOrder: number; qnaId: number; qna?: Partial<QnaMakerQnaSwagger>; displayText: string };

export type QnaMakerMetadataType = { [key: string]: string };

export enum QnaMakerQnaPairInternalRef {
    backendPair = 0,
    uiGlobalPair = 1,
    uiPromptPair = 2
}

export type QnaMakerQnaActiveLearningSuggestion = {
    clusterHead: string;
    suggestedQuestions?: [
        {
            question: string;
            autoSuggestedCount: number;
            userSuggestedCount: number;
            autoSuggestionCountFromGenerativeModel: number;
        }
    ];
    totalAutoSuggestedCount?: number;
    totalUserSuggestedCount?: number;
    totalAutoSuggestionCountFromGenerativeModel?: number;
};

export type QnaMakerQnaSwagger = {
    id: number;
    answer: string;
    source: string;
    sourceDisplayName?: string;
    parentQnaIds?: number[];
    questions: string[];
    isDocumentText: boolean;
    lastUpdatedDateTime: string;
    metadata: QnaMakerMetadataType;
    activeLearningSuggestions?: QnaMakerQnaActiveLearningSuggestion[];
    dialog: { isContextOnly: boolean; prompts: QnaMakerQnaPromptSwagger[] };
    internalRef?: QnaMakerQnaPairInternalRef;
};

export type QnaMakerSynonymSwagger = {
    id?: number;
    alterations: string[];
};
